import React from 'react';
import { Form, Input, Button, message } from 'antd';
import { withRouter } from 'react-router-dom';
import AuthService from '../services/AuthService';
import LocalStorage from '../data/LocalStorage';
import Constants from '../util/Constants';
import Links from '../data/Links';
import { connect } from 'react-redux';
import { Actions } from '../store/actions';
import InputRules from '../data/InputRules';

const layout = {
	labelCol: {
		span: 8,
	},
	wrapperCol: {
		span: 16,
	},
};

const Login = ({ login, loggedIn, ...props }) => {
	const onFinish = (values) => {
		AuthService.login(values.user.email, values.user.password)
			.then((user) => {
				LocalStorage.set(Constants.KEY_ACCESS_TOKEN, user.data[Constants.KEY_ACCESS_TOKEN]);
				LocalStorage.set(Constants.KEY_REFRESH_TOKEN, user.data[Constants.KEY_REFRESH_TOKEN]);
				login(user);
				return user;
			})
			.then(() => {
				message.success('Login Successful');
				props.history.push(Links.DASHBOARD);
			})
			.catch((error) => message.error('Credentials do not match!'));
	};

	return (
		<div className="login-form-container">
			<h1>Login Form</h1>
			<Form {...layout} name="login-form" onFinish={onFinish} className="login-form">
				<Form.Item name={['user', 'email']} label="Email" rules={InputRules.email}>
					<Input />
				</Form.Item>
				<Form.Item name={['user', 'password']} label="Password" rules={InputRules.password}>
					<Input.Password />
				</Form.Item>
				<Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 8 }}>
					<Button type="primary" htmlType="submit">
						Submit
					</Button>
				</Form.Item>
			</Form>
		</div>
	);
};

const mapStateToProps = (store) => ({
	loggedIn: store.session.loggedIn,
});

const mapDispatchToProps = (dispatch) => ({
	login: (user) => dispatch(Actions.login(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Login));
